import { useEffect, useState } from 'react';
import { csrfFetch } from '../utils/csrfFetch';

/**
 * What the signed-in user is shown (TODO #86 / #87), from GET /api/display:
 *   { thinkingDisplay: 'indicator'|'full', showUsage: boolean }
 *
 * Fetched once per page load and shared by every caller. Until it arrives,
 * and if it fails, usage numbers are hidden — the safe default for customers.
 * The server enforces the same rules; this only keeps the UI consistent.
 */

const HIDDEN = { thinkingDisplay: 'indicator', showUsage: false };
let cached = null;
let inflight = null;

function load() {
  if (!inflight) {
    inflight = csrfFetch('/api/display', { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : HIDDEN))
      .catch(() => HIDDEN)
      .then((v) => { cached = { ...HIDDEN, ...v }; return cached; });
  }
  return inflight;
}

/** Test hook: forget the cached settings. */
export function resetDisplaySettingsCache() {
  cached = null;
  inflight = null;
}

export function useDisplaySettings() {
  const [settings, setSettings] = useState(cached);
  useEffect(() => {
    let alive = true;
    if (!cached) load().then((v) => { if (alive) setSettings(v); });
    return () => { alive = false; };
  }, []);
  return { ...(settings || HIDDEN), loaded: !!settings };
}
